import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { initialize } from 'redux-form';
import { Button, Grid, Input, Icon, Radio } from 'semantic-ui-react';
import _ from 'lodash';

import { Main, Filter } from 'Containers/';
import { TitledCard } from 'Components/';
import {
  IngredientTable,
  withIngredientApi,
} from 'Pages/managerecipe/components/IngredientTable';
import { IngredientFieldEnum as Fields } from 'Common/FieldEnum';
import * as PagingActions from 'State/paging/actions';
import * as PagingTypes from 'State/paging/types';
import * as PagingSelectors from 'State/paging/selectors';
import * as PagingConstants from 'State/paging/constants';
import { EDIT_INGREDIENT_FORM_NAME } from 'Common/FormEnum';
import { cancelRequest } from 'State/actions';
import { SecurityAccess } from 'Common/Security/SecurityAccess';
import { ImportIngredients } from 'Pages/importingredients/ImportIngredients';

import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';
import { PopupTextCell } from 'Common/GridHelper';

import { RemoveReplaceIngredientModal } from './components/RemoveReplaceIngredientModal';

import 'PageStyles/manageingredient/index.less';

const withApiOptions = {
  searchOnMount: true,
};

const IngredientTableWithApi = withIngredientApi(
  IngredientTable,
  withApiOptions
);

class ManageIngredient extends Component {
  state = {
    searchParameters: {
      Search: '',
      ShowInvLinked: false,
      ShowInactive: false,
      UsedOnCycleMenu: false,
    },
    isRemoveReplaceModalOpen: false,
    removeReplaceIngredient: null,
  };

  componentWillUnmount() {
    const { loading, cancelRequest } = this.props;
    if (loading) {
      cancelRequest(
        PagingTypes[`${PagingConstants.primaryPrefix}PAGING_FETCHING`]
      );
    }
  }

  setToggle = (field) => (e, data) => {
    const { searchParameters } = this.state;
    const updatedSearchParameters = {
      ...searchParameters,
      [field]: data.checked,
    };

    this.setState({
      searchParameters: updatedSearchParameters,
    });
  };

  onTextChange = (e) => {
    const { searchParameters } = this.state;
    const { setPageNumber } = this.props;

    const updatedSearchParameters = {
      ...searchParameters,
      Search: e.target.value,
    };

    this.setState({
      searchParameters: updatedSearchParameters,
    });
    setPageNumber(1);
  };

  onPageChange = (page) => {
    this.props.setPageNumber(page + 1);
  };

  onPageSizeChange = (pageSize) => {
    this.props.setPageSize(pageSize, 1);
  };

  onSortedChange = (sorted) => {
    this.props.setSortColumn(sorted);
  };

  onFilteredChange = (filtered) => {
    // All's value is null, ignore filters with null values
    const columnFilters = (filtered || []).filter((x) => !_.isNil(x.value));
    this.props.setFilter(columnFilters, PagingFilterTypeEnum.MatchFromStart);
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        shown: true,
        isReadOnly: isReadOnly,
      },
    };
  };

  handleAddIngredient = () => {
    const { history, initialize } = this.props;
    history.push('/manageingredient/edit');
    initialize(EDIT_INGREDIENT_FORM_NAME, {});
  };

  handleImportIngredient = () => {
    const { history } = this.props;
    history.push('/importingredients');
  };

  handleRemoveReplaceClick = (ingredient) => {
    this.setState({
      isRemoveReplaceModalOpen: true,
      removeReplaceIngredient: ingredient,
    });
  };

  onRemoveReplaceModalClose = () => {
    this.setState({ isRemoveReplaceModalOpen: false });
  };

  additionalColumns = [
    {
      Header: 'Allergens',
      accessor: Fields.Allergens,
      style: {
        textAlign: 'left',
      },
      Cell: ({ original }) => {
        const value = original[Fields.Allergens];
        return <PopupTextCell text={value} />;
      },
      sortable: true,
      resizable: true,
      visibility: true,
      show: false,
      filterable: true,
      addToEnd: true,
    },
    {
      Header: 'Attributes',
      accessor: Fields.Attributes,
      style: {
        textAlign: 'left',
      },
      Cell: ({ original }) => {
        const value = original[Fields.Attributes];
        return <PopupTextCell text={value} />;
      },
      sortable: true,
      resizable: true,
      visibility: true,
      show: false,
      filterable: true,
      addToEnd: true,
    },
  ];

  render() {
    const { isReadOnly } = this.props;
    const {
      searchParameters,
      isRemoveReplaceModalOpen,
      removeReplaceIngredient,
    } = this.state;

    const { ShowInactive, UsedOnCycleMenu } = searchParameters;
    return (
      <Fragment>
        <Filter title="Manage Ingredients">
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column textAlign="right">
                <Radio
                  onChange={this.setToggle('UsedOnCycleMenu')}
                  toggle
                  checked={UsedOnCycleMenu}
                  label="Search Cycle Menu"
                />
              </Grid.Column>
              <Grid.Column textAlign="right" width={5}>
                <Radio
                  onChange={this.setToggle('ShowInactive')}
                  toggle
                  checked={ShowInactive}
                  label="Show Inactive / Deactivated Only"
                />
              </Grid.Column>
              <SecurityAccess path={ImportIngredients.path}>
                {(disabled) => {
                  return (
                    !disabled && (
                      <Grid.Column textAlign="right">
                        <Button onClick={this.handleImportIngredient}>
                          Import Ingredients
                        </Button>
                      </Grid.Column>
                    )
                  );
                }}
              </SecurityAccess>

              <Grid.Column textAlign="right">
                <Button
                  onClick={this.handleAddIngredient}
                  disabled={isReadOnly}
                >
                  Add Ingredient
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth {...this.getMainProps()}>
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column>
                <Input
                  value={searchParameters.Search}
                  placeholder="Smartest Lunchroom Search"
                  fluid
                  icon={<Icon name="search" />}
                  iconPosition="left"
                  onChange={this.onTextChange}
                />
              </Grid.Column>
              <Grid.Column />
            </Grid.Row>
          </Grid>
          <TitledCard title="Ingredients">
            <IngredientTableWithApi
              secondIngredientModalIsOpen={isRemoveReplaceModalOpen}
              additionalColumns={this.additionalColumns}
              searchParameters={searchParameters}
              onPageChange={this.onPageChange}
              onPageSizeChange={this.onPageSizeChange}
              controlledPaging={true}
              manual={true}
              onSortedChange={this.onSortedChange}
              onFilteredChange={this.onFilteredChange}
              handleRemoveReplaceClick={this.handleRemoveReplaceClick}
            />
          </TitledCard>
          {isRemoveReplaceModalOpen && (
            <RemoveReplaceIngredientModal
              isRemoveReplaceModalOpen={isRemoveReplaceModalOpen}
              onRemoveReplaceModalClose={this.onRemoveReplaceModalClose}
              ingredient={removeReplaceIngredient}
            />
          )}
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const primaryPagingSelectors = PagingSelectors.commonStatePagingSelectors(
    PagingConstants.primaryStateName
  );
  return {
    loading: primaryPagingSelectors.getLoading(state),
  };
};
const primaryPagingActions = PagingActions.commonStatePagingActions(
  PagingConstants.primaryPrefix
);

const mapDispatchToProps = {
  setPageNumber: primaryPagingActions.setPageNumber,
  setPageSize: primaryPagingActions.setPageSize,
  setFilter: primaryPagingActions.setFilter,
  setSortColumn: primaryPagingActions.setSortColumn,
  initialize,
  cancelRequest,
};

ManageIngredient = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageIngredient)
);

export { ManageIngredient };



// WEBPACK FOOTER //
// ./src/pages/manageingredient/ManageIngredient.js